import React from "react";
import { LINKS } from "@consts";
import ErrorPage from "./ErrorPage";
import NotFoundIcon from "./NotFoundIcon";

const NotFoundErrorPage = ({ message = "Page not found", explanation = "We can't find the page you're looking for." }) => {
  const pageLinks = [
    { url: "/", text: "Go to home page" },
    { url: LINKS.HYRO_SUPPORT, text: "Contact support" }
  ];

  return (
    <ErrorPage
      code="404"
      message={message}
      explanation={explanation}
      links={pageLinks}
      Icon={NotFoundIcon}
    />
  );
};

export default NotFoundErrorPage;
